// extracted by mini-css-extract-plugin
export default {"main":"PrivacyScreen_main__B-Fc5"};